import { SingletonEnginnering } from "../../../flowchart/nodes/_service/singletonEngineering";
import MathEngine from "../../../flowchart/utils/MathEngine";
import { NumberFormat } from "../../../flowchart/utils/tools";


class Mapping {
  constructor(newObject = {}) {
    this.parentId = newObject.parentId ? newObject.parentId : -9999
    this.id = newObject.id ? newObject.id : 0
    this.variable = newObject.variable ?  newObject.variable : "Novo Indicador"
    this.mapping = newObject.mapping ?  newObject.mapping : "cr|1_1|Atributos|W"
    this.value = newObject.value ?  newObject.value : "0,00"
    this.type = newObject.type ?  newObject.type : "O"
    this.operation = newObject.operation ?  newObject.operation : "paplos"

    this.clone = function() {
      return new Mapping({...this})
    }

    this.setValue = function(){
      if(SingletonEnginnering.isLoaded){
        let result = MathEngine.sentence(this.mapping)
        this.value = NumberFormat(result.value)
        return this.value
      }
      else{
        let that = this
        setTimeout(that.setValue, 1000)
      }
    }

    this.getMappingAndValue = function(){
      return { item: this.mapping, value: NumberFormat(this.value) }
    }
  }
}

export default Mapping